import React from "react";
import Modal from "react-bootstrap/Modal";
// import { useNavigate } from "react-router-dom";
import "./ShopCatalogModal.css"; // Create this CSS file

const categories = [
  {
    title: "Abrasives, Adhesives & Sealants",
    path: "Abrasives_Adhesives_and_Sealants",
    img: "Abrasivesc.png",
  },
  {
    title: "Agriculture, Garden & Landscaping",
    path: "Agriculture_Garden_Landscaping",
    img: "Agriculture.png",
  },
  {
    title: "Automotive Supplies & Lubricants",
    path: "Automotive_Supplies_and_Lubricants",
    img: "Automative.png",
  },
  {
    title: "Bearings & Power Transmission",
    path: "Bearings_and_Power_Transmission",
    img: "Bearings.png",
  },
  {
    title: "Building & Construction Supplies",
    path: "Building_and_Construction_Supplies",
    img: "Building.png",
  },
  {
    title: "Cleaning Equipment",
    path: "Cleaning_Equipment",
    img: "Cleaning.png",
  },
  {
    title: "Electricals & Electronics",
    path: "Electricals_and_Electronics",
    img: "Electricals.png",
  },
  {
    title: "Fabrication & Customized Products",
    path: "Fabrication_Customized_Products",
    img: "Fabrication.png",
  },
  {
    title: "Fasteners",
    path: "Fasteners",
    img: "Fasteners.png",
  },
  {
    title: "Furniture, Hospitality & Food Services",
    path: "Furniture_Hospitality",
    img: "Furniture.png",
  },
  {
    title: "Hardware, Cutting & Hand Tools",
    path: "Hardware_Cutting_Hand_Tools",
    img: "Hardware.png",
  },
  {
    title: "Hydraulics & Pneumatics",
    path: "Hydraulics_Pneumatics",
    img: "Hydraulics.png",
  },
  {
    title: "IT Supplies",
    path: "IT_Supplies",
    img: "ITSupplies.png",
  },
  {
    title: "Lab Supplies",
    path: "Lab_Supplies",
    img: "lab.png",
  },
  {
    title: "Luminaires, LEDs & Lights",
    path: "Luminaires_LEDs_Lights",
    img: "led.png",
  },
  {
    title: "Material Handling & Packaging",
    path: "Material_Handling_Packaging",
    img: "Packaging.png",
  },
  {
    title: "Mild Steel",
    path: "Mild_Steel",
    img: "MildSteel.png",
  },
  {
    title: "Motors & Pumps",
    path: "Motors_and_Pumps",
    img: "Motors.png",
  },
  {
    title: "Non Ferrous Products",
    path: "Non_Ferrous_Products",
    img: "NonFerrousProducts.png",
  },
  {
    title: "Office Stationery & Admin Supplies",
    path: "Office_Stationery_Admin_Supplies",
    img: "OfficeStationery.png",
  },
  {
    title: "Paints, Powders & Coatings",
    path: "Paints_Powders_Coatings",
    img: "Paints.png",
  },
  {
    title: "Plates, Sheets, Coils & Rounds",
    path: "Plates_Sheets_Coils_Rounds",
    img: "Plates.png",
  },
  {
    title: "Plumbing, Pipes & Fittings",
    path: "Plumbing_Pipes_Fittings",
    img: "Plumbing.png",
  },
  {
    title: "Power Tools",
    path: "Power_Tools",
    img: "PowerTools.png",
  },
  {
    title: "Railway Spares & Equipment",
    path: "Railway_Spares_Equipment",
    img: "Railway.png",
  },
  {
    title: "Roofing Sheets",
    path: "Roofing_Sheets",
    img: "Roofing.png",
  },
  {
    title: "Safety & PPE Supplies",
    path: "Safety_PPE_Supplies",
    img: "Safety.png",
  },
  {
    title: "Solar Products",
    path: "Solar_Products",
    img: "Solar.png",
  },
  {
    title: "Stainless Steel Products",
    path: "Stainless_Steel_Products",
    img: "Stainless.png",
  },
  {
    title: "Testing & Measuring Instruments",
    path: "Testing_Measuring_Instruments",
    img: "Testing.png",
  },
  {
    title: "Tooling & Cutting",
    path: "Tooling_Cutting",
    img: "Tooling.png",
  },
  {
    title: "Welding Accessories",
    path: "Welding_Accessories",
    img: "welder.png",
  },
  {
    title: "Wire Meshes & Perforated Sheets",
    path: "Wire_Meshes_Perforated_Sheets",
    img: "Wire.png",
  },
];

const ShopCatalogModal = React.forwardRef((props, ref) => {
  const { show, onHide } = props;
  // const navigate = useNavigate();

  const handleCategoryClick = (categoryPath) => {
    onHide();
    // navigate("/material-catalog-shopwise", {
    //   state: { categoryPath: categoryPath },
    // });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      keyboard={false}
      ref={ref}
      dialogClassName="shop-catalog-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Product Categories</Modal.Title>
      </Modal.Header>

      <Modal.Body className="shop-catalog-modal-body">
        <div className="category-card-grid-modal">
          {categories.map((item, index) => (
            <div
              key={index}
              className="category-card-modal"
              onClick={() => handleCategoryClick(item.path)}
              style={{ cursor: "pointer" }}
            >
              {/* <img
                src={`https://firebasestorage.googleapis.com/v0/b/byizzy-5aa57.appspot.com/o/website%2FShop%20By%20Categories%20main%20images%2F${item.img}?alt=media`}
                alt={item.title}
              /> */}

               <img
  src={`/ShopBycategories/${item.img}`}
  alt={item.title}
/>
              <span>{item.title}</span>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default ShopCatalogModal;
